/* eslint-disable no-alert */
import React, {useState, useEffect, useContext} from 'react';
import {navigate} from "gatsby";

import JobListContext from '../../../context/jobListContext';
import filterHelper from "../../../../hooks/useFilterHelper";

import DropDown from '../../../../components/dropdown';
import SummaryCard from '../jobSummaryCard';

import { computeSummaryData } from "./helper";
import { DropdownCtn, HeadingCtn, HeadingDropdownCtn, JobTypeBtn, JobTypeCtn, SummaryList, Empty } from './index.style';


const JobSummaryCardList: React.FC<any> = (): React.ReactElement => {
  const { reactiveJobList, plannedJobList, updateReactiveFilters, filtersReactive, filtersPlanned, updatePlannedFilters } = useContext(JobListContext);

  const [timePeriod, setTimePeriod] = useState('thisMonth');
  const [viewReactive, setViewReactive] = useState(true);
  const [reactiveSummaryList, setReactiveSummaryList] = useState([]);
  const [plannedSummaryList, setPlannedSummaryList] = useState([]);

  const { filterByDate, getDatePeriod } = filterHelper();

  const updateSummaryData = (newDate: string) => {
   let newReactiveData = filterByDate(newDate, reactiveJobList, 'reactive');
   let newPlannedData = filterByDate(newDate,plannedJobList,'planned');

    if(reactiveJobList.length > 0) {
      let summaryData = computeSummaryData(newReactiveData,'reactive');
      setReactiveSummaryList(Object.keys(summaryData).map(status => <SummaryCard summary={summaryData[status]} onClick={() => handleClick(status, 'reactive',newDate)}/>))
    }

    if(plannedJobList.length > 0) {
      let summaryData = computeSummaryData(newPlannedData, 'planned');
      setPlannedSummaryList(Object.keys(summaryData).map(status => <SummaryCard summary={summaryData[status]} onClick={() => handleClick(summaryData[status].status,'planned',newDate)}/>))
    }
  };

  const handleClick = (status: string, type: string,newDate: string) => {
    if(type === 'reactive') {
      navigate('/app/reactiveMaintenance');
      updateReactiveFilters({
        ...filtersReactive,
        statusFilters: status,
        dateFilter: getDatePeriod(newDate),
      })
    } else if(type === 'planned') {
      navigate('/app/plannedMaintenance');
      updatePlannedFilters({
        ...filtersPlanned,
        statusFilter: status,
        dateFilter: getDatePeriod(newDate),
      })
    }
  };

  useEffect(() => {
    updateSummaryData('thisMonth');
  }, [reactiveJobList, plannedJobList]);

  function handleChange(newValue: any) {
    updateSummaryData(newValue);
    setTimePeriod(newValue);
  }

  return (
    <React.Fragment>
      <HeadingCtn>
        <HeadingDropdownCtn>
          <span>Reports</span>
          <DropdownCtn>
            <span>Show results for</span>
            <div>
              <DropDown defaultVal={1} optionList="dateFilter" onChange={handleChange} />
            </div>
          </DropdownCtn>
        </HeadingDropdownCtn>
        <JobTypeCtn>
          <JobTypeBtn
            active={viewReactive}
            onClick={(e): void => {
              e.preventDefault();
              setViewReactive(true);
              updateSummaryData(timePeriod);
            }}
          >
            REACTIVE
          </JobTypeBtn>
          <JobTypeBtn
            active={!viewReactive}
            onClick={(e): void => {
              e.preventDefault();
              setViewReactive(false);
              updateSummaryData(timePeriod);
            }}
          >
            PLANNED
          </JobTypeBtn>
        </JobTypeCtn>
      </HeadingCtn>
      <SummaryList>
        {viewReactive && reactiveSummaryList}
        {!viewReactive && plannedSummaryList}
        <Empty />
        <Empty />
      </SummaryList>
    </React.Fragment>
  );
};

export default JobSummaryCardList;
